<template>
  <div id="company">
    <v-fab-transition>
      <v-btn
        color="primary"
        fab
        large
        dark
        class="v-btn--open-dialog"
        @click="parametersDialog = !parametersDialog"
        style="z-index: 100"
      >
        <v-icon v-if="!parametersDialog">keyboard_arrow_right</v-icon>
        <v-icon v-if="parametersDialog">mdi-close</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="parametersDialog" max-width="600px">
      <v-card class="mx-auto" max-width="1000">
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-domain"
                  v-model="companies"
                  :items="uniqueCompanies"
                  label="Companies"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="isAdminRole">
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-account-multiple"
                  v-model="participants"
                  :items="uniqueParticipants"
                  label="Participants"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-menu
                  v-model="from"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fromDate"
                      label="From"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    @input="from = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  v-model="to"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="toDate"
                      label="To"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    @input="to = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-btn
                @click="parametersDialog = !parametersDialog"
                color="red"
                dark
                >Close</v-btn
              >
              <div class="flex-grow-1"></div>
              <v-btn @click="getFeedbackData()" color="info">Update</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container style="width: 100%; max-width: 1060px">
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <p class="text-center display-1 primary--text">Core company feedback</p>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Participants</v-toolbar-title
              ><a
                class="reset"
                @click="resetFilters()"
                style="display: true; margin-left: 5px"
                >reset all</a
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center">
              <div id="participants-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Support</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="support-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Communication</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="communication-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Impact</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="impact-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Performance</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="performance-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Value</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="value-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Feedback</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center" style="margin: 0 15px">
              <table
                id="feedback-table"
                class="table table-hover dc-data-table"
              >
                <thead>
                  <tr class="header">
                    <th>Comments</th>
                    <th style="width: 200px">Company</th>
                  </tr>
                </thead>
              </table>
            </v-row>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import CompanySurvey from "../classes/CompanySurvey2022";
import moment from "moment";
export default {
  data: () => ({
    graphData: {},
    loading: false,
    participantsChart: null,
    professionalChart: null,
    impactChart: null,
    supportChart: null,
    valueChart: null,
    recommendChart: null,
    pieLabel: {},
    pieColor: {},

    parametersDialog: false,
    uniqueCompanies: [],
    uniqueParticipants: [],
    from: false,
    fromDate: null,
    to: false,
    toDate: null,
    participants: "All",
    service: "All",
    participantsLoaded: false,
    companies: "All"
  }),
  async mounted() {
    this.loading = true;
    const companySurvey = new CompanySurvey(null);
    await companySurvey.getGraphData();
    this.uniqueCompanies = await companySurvey.getUniqueCompanyNames();
    this.uniqueCompanies.unshift("All");
    this.uniqueParticipants = await companySurvey.getUniqueParticipants();
    // this.uniqueParticipants.unshift("All");

    this.pieLabel = {
      0: "F",
      1: "M",
      average: "Avg",
      excellent: "Excel",
      good: "Good",
      poor: "Poor",
      verygood: "V.Good",
      yes: "Yes",
      no: "No",
      dontknow: "Dont Know",
      null: "Ignore"
    };
    this.pieColor = {
      excellent: "#B2D732",
      verygood: "#66B032",
      good: "#375F1B",
      average: "#e6550d",
      poor: "#c62828",
      no: "#c62828",
      yes: "#B2D732",
      dontknow: "#e6550d",
      null: "#e376c2"
    };

    await this.getFeedbackData();
    this.drawCharts();
    this.loading = false;
  },
  methods: {
    async getFeedbackData() {
      this.parametersDialog = false;
      this.loading = true;
      let filter = null;
      let query = [];

      if (this.companies && this.companies !== "All") {
        query.push({ companyName: { contains: this.companies } });
      }

      if (this.participants && this.participants !== "All") {
        query.push({ participants: { contains: this.participants } });
      }

      if (this.fromDate && this.toDate) {
        const from = moment(this.fromDate).toISOString();
        const to = moment(this.toDate).toISOString();
        query.push({
          createdAt: {
            between: [from, to]
          }
        });
      }

      if (this.service && this.service !== "All") {
        query.push({ service: { contains: this.service } });
      }

      if (!this.isAdminRole) {
        Auth.currentAuthenticatedUser().then(user => {
          filter = {};
          query.push({ participants: { contains: user.attributes.email } });

          query.forEach(q => {
            Object.assign(filter, q);
          });
        });
      } else {
        if (query.length > 0) {
          filter = {};
          query.forEach(q => {
            Object.assign(filter, q);
          });
        }
      }

      const companySurvey = new CompanySurvey(filter);
      this.graphData = await companySurvey.getGraphData();

      this.drawCharts();
      this.loading = false;
    },
    drawCharts() {
      var cf = crossfilter(this.graphData);

      // Support Pie Chart
      this.renderSupportChart(cf);

      // Communication Bar Chart
      this.renderCommunicationChart(cf);

      // Impact Pie Chart
      this.renderImpactChart(cf);

      // Performance Pie Chart
      this.renderPerformanceChart(cf);

      // Value Pie Chart
      this.renderValueChart(cf);

      // // Recommend Pie Chart
      // this.renderRecommendChart(cf);

      // // Feedback Table
      this.renderFeedbackTable(cf);

      dc.renderAll();

      this.loading = false;
    },
    renderParticipantsChart(cf) {
      const that = this;
      this.participantsChart = dc.barChart("#participants-chart");
      var participantsDimension = cf.dimension(function(d) {
        let participant = d.participants
          .substring(0, d.participants.lastIndexOf("@"))
          .replace(".", " ")
          .toLowerCase()
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
        return participant;
      });
      var participantsGrouping = participantsDimension.group();
      this.participantsChart
        .width(768)
        .height(380)
        .margins({ top: 0, right: 0, bottom: 105, left: 35 })
        .x(d3.scaleBand())
        .xUnits(dc.units.ordinal)
        .brushOn(false)
        //.xAxisLabel('')
        .yAxisLabel("Health Assessments")
        .dimension(participantsDimension)
        .barPadding(0.1)
        .outerPadding(0.05)
        .group(participantsGrouping)
        .on("postRender", function(c) {
          that.adjustBarChartLabels(c);
        });
    },
    renderSupportChart(cf) {
      const that = this;
      this.supportChart = dc.pieChart("#support-chart");
      var supportDimension = cf.dimension(function(d) {
        var ret = d.event === null ? "null" : d.event;
        return ret;
      });
      var supportGrouping = supportDimension.group();
      that.supportChart
        .width(150)
        .height(150)
        .dimension(supportDimension)
        .group(supportGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function(p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function(d) {
          return that.pieColor[d];
        });
    },
    renderCommunicationChart(cf) {
      const that = this;
      this.communicationChart = dc.pieChart("#communication-chart");
      var communicationDimension = cf.dimension(function(d) {
        var ret = d.communication === null ? "null" : d.communication;
        return ret;
      });
      var communicationGrouping = communicationDimension.group();
      that.communicationChart
        .width(150)
        .height(150)
        .dimension(communicationDimension)
        .group(communicationGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function(p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function(d) {
          return that.pieColor[d];
        });
    },
    renderImpactChart(cf) {
      const that = this;
      this.impactChart = dc.pieChart("#impact-chart");
      var impactDimension = cf.dimension(function(d) {
        var ret = d.impact === null ? "null" : d.impact;
        return ret;
      });
      var impactGrouping = impactDimension.group();
      that.impactChart
        .width(150)
        .height(150)
        .dimension(impactDimension)
        .group(impactGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function(p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function(d) {
          return that.pieColor[d];
        });
    },
    renderPerformanceChart(cf) {
      const that = this;
      this.performanceChart = dc.pieChart("#performance-chart");
      var performanceDimension = cf.dimension(function(d) {
        var ret = d.performance === null ? "null" : d.performance;
        return ret;
      });
      var performanceGrouping = performanceDimension.group();
      that.performanceChart
        .width(150)
        .height(150)
        .dimension(performanceDimension)
        .group(performanceGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function(p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function(d) {
          return that.pieColor[d];
        });
    },
    renderValueChart(cf) {
      const that = this;
      this.valueChart = dc.pieChart("#value-chart");
      var valueDimension = cf.dimension(function(d) {
        var ret = d.valueformoney === null ? "null" : d.valueformoney;
        return ret;
      });
      var valueGrouping = valueDimension.group();
      that.valueChart
        .width(150)
        .height(150)
        .dimension(valueDimension)
        .group(valueGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function(p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function(d) {
          return that.pieColor[d];
        });
    },
    renderRecommendChart(cf) {
      const that = this;
      this.recommendChart = dc.pieChart("#recommend-chart");
      var recommendDimension = cf.dimension(function(d) {
        var ret = d.recommend === null ? "null" : d.recommend;
        return ret;
      });
      var recommendGrouping = recommendDimension.group();
      that.recommendChart
        .width(150)
        .height(150)
        .dimension(recommendDimension)
        .group(recommendGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function(p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function(d) {
          return that.pieColor[d];
        });
    },
    renderFeedbackTable(cf) {
      var feedbackTable = dc.dataTable("#feedback-table");
      var feedbackDimension = cf.dimension(function(d) {
        return d.feedback;
      });

      feedbackTable
        .dimension(feedbackDimension)
        .columns(["feedback", "participants"])
        .size(100)
        .sortBy(function(d) {
          return d.participants;
        })
        .order(d3.ascending)
        .on("pretransition", function(table) {
          var body = table.selectAll("tbody");
          body.selectAll("tr").style("display", function(d) {
            if (d.feedback === null) {
              return "none";
            }
          });
        });
    },
    resetFilters() {
      this.participantsChart.filterAll();
      this.qualityChart.filterAll();
      this.professionalChart.filterAll();
      this.impactChart.filterAll();
      this.supportChart.filterAll();
      this.valueChart.filterAll();
      this.recommendChart.filterAll();
      dc.redrawAll();
    },
    adjustBarChartLabels(chart) {
      chart
        .svg()
        .selectAll(".axis.x text")
        .on("click", function(d) {
          chart.filter(d);
          dc.redrawAll();
          scrollTo(d);
        })
        .style("text-anchor", "end")
        .attr("dx", function(d) {
          return "-0.6em";
        })
        .attr("transform", function(d) {
          return "rotate(-90, -4, 9) ";
        });
    }
  },
  computed: {
    async isAdminRole() {
      const user = await Auth.currentAuthenticatedUser();
      const awsGroups =
        user.signInUserSession.accessToken.payload["cognito:groups"];
      if (awsGroups) {
        const roles =
          user.signInUserSession.accessToken.payload["cognito:groups"];
        return roles.includes("ADMIN");
      }
    }
  }
};
</script>
<style>
.dc-table-section {
  display: none !important;
}
.v-btn--open-dialog {
  top: 90px;
  position: fixed;
  margin: 0 0 16px 16px;
}
</style>
